import Module from "./Module";
import UnderConstruction from "./views/UnderConstruction.vue";
import WhatsappAutoSender from "./views/alert/WhatsappAutoSender.vue";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/under-construction",
    component: Module,
    children: [
        {
            path: "",
            name: "under_construction",
            component: UnderConstruction,
            meta: requireAuth,
        },
        {
            path: "alert",
            component: Module,
            children: [
                {
                    path: "fitur-wa-auto-sender",
                    name: "ALERT_FITUR_WA",
                    component: WhatsappAutoSender,
                    meta: requireAuth,
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
